export default __webpack_public_path__ + "d3bba4e1b1a916f41fd2fe2f7ee448ef.webp";